export module GlobalModels {

    export enum AdressTypes {
        Kunde = 1,
        Rechnungsadresse = 2,
        Architekt = 3,
        Lieferant = 4
    }

    export interface Dictionary<T> {
        [Key: string] : T;
    }
    
}